
import { NgModule } from '@angular/core';

import {MatCardModule } from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule } from '@angular/material/menu';
import {MatToolbarModule } from '@angular/material/toolbar';
import {MatIconModule } from '@angular/material/icon';
import {MatRadioModule} from '@angular/material/radio';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {MatListModule} from '@angular/material/list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTooltipModule} from '@angular/material/tooltip';


function getCustomPaginatorLabel() {
  const paginatorIntl = new MatPaginatorIntl();
  
  const rangeLabel = (page: number, pageSize: number, length: number) => {
    const allPages = Math.ceil(length / pageSize);
    if (length == 0 || pageSize == 0) { return `Page 1 of ${allPages}`; }
    return `Page ${page+1} of ${allPages}`;
  }
  
  paginatorIntl.nextPageLabel = 'Next';
  paginatorIntl.previousPageLabel = 'Previous';
  paginatorIntl.getRangeLabel = rangeLabel;
  return paginatorIntl;

}

const modules = [
  MatButtonModule,
  MatMenuModule,
  MatToolbarModule,
  MatIconModule,
  MatCardModule,
  MatRadioModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatCheckboxModule,
  MatPaginatorModule,
  MatListModule,
  MatProgressSpinnerModule,
  MatSidenavModule,
  MatTooltipModule
];

@NgModule({
  imports: [...modules],
  exports: [...modules],
  providers: [
    { provide: MatPaginatorIntl, useValue: getCustomPaginatorLabel() }
  ]
})
export class MaterialModule {}

